import { PageDescription, PageTitle, PageWrapper } from '@style/pages/page.style';

// import { UserNotifications } from './user-notifications/user-notifications';
import { UserProfile } from './user-profile/user-profile';
import { WrapperForm } from './user-settings.page-style';

export const UserSettingsPage = () => (
  <PageWrapper>
    <PageTitle>User settings</PageTitle>
    <PageDescription>Profile Details</PageDescription>
    <WrapperForm>
      <UserProfile />
    </WrapperForm>
    {/*<Title level={4} mb={4} weight={400}>*/}
    {/*  Email notifications*/}
    {/*</Title>*/}
    {/*<Text level='m' paragraph>*/}
    {/*  What types of activity notifications would you like to receive?*/}
    {/*</Text>*/}
    {/*<UserNotifications />*/}
  </PageWrapper>
);
